import React, { useState,useEffect, useContext } from "react"
import styled from "styled-components"
import Loader1 from "../../interceptors/loader-interceptor"
import { JourneyContext } from "../context/journeyContext"
import { findCurrentJourneyCode, getDateInFormat } from "../services/helperFunctions"
import {paymentText, saveApplication, saveTransactionDetails ,checkPaymentStatus2,paymentTextDecrypt, fetchAllJourneyData} from "../../services/apiservice"
import { ErrorContext } from "../context/errorContext";
import * as lookup from "../../../static/lookup.json"
import { errorToastr } from "../../services/error-handler"

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > input {
  }
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    min-height: 2rem;
  }
`

export default function UnsuccessfulTransactionBasba(props) {
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const[errorState, setErrorState] = useContext(ErrorContext);
  const[checkstatus,setCheckstatus] =useState(false);
  // old pay-later-logic
  /* const handlePayLater = () => {
    props.setCurrentPageIndex(prev => prev + 1)
    props.setCurrentSectionIndex(0) // this moves to first section of next page

    setJourneyState((prev) => {
      return ({
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
      })
    })

  } */

  const registerForBasba = async () => {
    const paymentPayload = {
      journeyId: journeyState.journeyId,
      module: "basba"
    }
    paymentText(paymentPayload)
      .then(res => {
        const redirectUrlPayload = {
          applicationNumber: journeyState.applicationNo,
          journeyId: journeyState.journeyId,
          source: journeyState.channel,
          module: "payment",
        }

        let abortTransactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Aborted',
          srcTraceId: res.data.payload.srcTraceId,
          amount: res.data.payload.amount,
          paymentTxnId: 0,
          source: 'ISNP',
          paymentTxnDate: res.data.payload.applicationLaunchDate,
        }
        saveTransactionDetails(abortTransactionPayload).then(() => {
          const data = JSON.stringify(redirectUrlPayload)
          var encodedStringBtoA = btoa(data)
          let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
          if (`${process.env.DEVELOPMENT}` === "Y") {
            const url = `${process.env.PAYMENT_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/payment-redirection/`;
            window.open(url, "_self");
          }
          else if (`${process.env.DEVELOPMENT}` === "N") {
            const url = `${process.env.PAYMENT_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/${productKey}/payment-redirection/`;
            window.open(url, "_self");
          }
        })
        .catch(err => { })
      })
      .catch(error => {
        console.log(error)
      })

  }

  return (
    <>
    <Loader1/>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
          .unsuccessAmount{
            display:flex;
            width:100% !important;
            flex-wrap: wrap;
          }
              `}
      </style>
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                    <h1 className="iselect-heading">
                      Failed to create Lien
                    </h1>
                  </div>
                  <div className="app-quatation nri-mt-space hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>

                <div className="iselect-padding payment-design successful-page">
                  <div className="success-content">
                    {" "}
                    <img src="images/unsuccess.png" />
                    <p style={{ marginTop: "15px" }}>
                     Your Lien has not been created. Please try again
                    </p>
                  </div>
                  <div className="input-payment">
                    <div className="unsuccessAmount">
                    {/* <div className="row iselect-mg-bottom">
                      <div className="col-lg-4 col-md-12 col-12 all-box-padding-right">
                        <InputContainer className="form-group">
                          <label className="input-label">Transaction Status:</label>
                          <input
                            className="form-control"
                            type="text"
                            name="tstatus"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.status || "FAIL"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                      <div className="col-lg-4 col-md-12 col-12 all-box-padding-middle">
                        <InputContainer className="form-group">
                          <label className="input-label">
                            Transaction Date & Time:
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="tdate"
                            // required={true}
                            placeholder={getDateInFormat(journeyState.paymentDecryptData?.paymentTxnDate/1000) || journeyState.paymentDecryptData?.paymentTxnDate || "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                      <div className="col-lg-4 col-md-12 col-12 all-box-padding-left">
                        <InputContainer className="form-group">
                          <label className="input-label">Paid From:</label>
                          <input
                            className="form-control"
                            type="text"
                            name="pfrom"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.paymentMethod || "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                    </div>
                    <div className="row iselect-mg-bottom">
                      <div className="col-lg-4 col-md-12 col-12 all-box-padding-right">
                        <InputContainer className="form-group">
                          <label className="input-label">
                            Transaction Reference Number:
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="trefno"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.paymentTxnId || "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                      <div className="col-lg-4 col-md-12 col-12 all-box-padding-middle">
                        <InputContainer className="form-group">
                          <label className="input-label">
                            Payment Amount ( <span className="fa fa-rupee"></span>):
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="pamount"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.amount || journeyState.premium || "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                    </div> */}
                    </div>
                    <div>

                  </div>
                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-right">
                        <a
                          style={{
                            marginRight: "5px",
                          }}
                        >
                          {" "}
                          <input
                            className="previous-btn cen text-uppercase"
                            style={{
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                            }}
                            type="submit"
                            value={"Retry"}
                            onClick={registerForBasba}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="clearfix"></div>
                {/* <!--mobile view button--> */}
                <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                  <div className="iselect-mg-bottom">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                        <div className="previous-btn cen">
                          <a>
                            {" "}
                            <button
                              type="submit"
                              value="button1"
                              style={{
                                backgroundColor: "transparent",
                                padding: "0px 10px",
                                border: "none",
                                color: "#fff",
                              }}
                              onClick={registerForBasba}
                            >
                              Retry
                            </button>{" "}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}